import { render } from "./CompanyReviewsList.vue?vue&type=template&id=11d1d482"
import script from "./CompanyReviewsList.vue?vue&type=script&lang=js"
export * from "./CompanyReviewsList.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__